module.exports = __webpack_public_path__ + "img/icon-arrow-left.6d69c364.svg";